'use client';

import CartEmpty from '@/components/cart/cart-empty';
import CartList from '@/components/cart/cart-list';
import CartTotalBox from '@/components/cart/cart-total-box';
import { CartProvider } from '@/hooks/use-cart';
import { useAppDispatch } from '@/lib/client-hook/use-app-dispatch';
import { useDictionary } from '@/lib/context/locale-provider';
import { Languages } from '@/lib/dictionaries';
import loadingImage from '@/public/images/loading.gif';
import { cartApi, useGetCartsQuery } from '@/slice/cartApi';
import { setErrorMessage } from '@/slice/error';
import Image from 'next/image';
import React, { useEffect } from 'react';

function CartWrap({ lang }: { lang: Languages }) {
  const dispatch = useAppDispatch();
  const dict = useDictionary();
  const { data, isLoading } = useGetCartsQuery();

  React.useEffect(() => {
    dispatch(cartApi.util.invalidateTags(['Cart']));
  }, []);

  useEffect(() => {
    if (data && data.warningItemList.length > 0) {
      let warningMessage = '';
      for (const wItem of data.warningItemList) {
        warningMessage += wItem.userItemName + '\n';
      }

      warningMessage += dict!.cart.availableQuantityChanged;

      dispatch(setErrorMessage(warningMessage));
    }
  }, [data]);

  if (!data && isLoading) {
    return (
      <div className="w-full h-[calc(100vh-60px)] lg:h-[calc(100vh-80px)] flex flex-col items-center gap-5 pt-[120px] lg:pt-[220px]">
        <Image src={loadingImage} alt="loading" width={50} height={50} />
      </div>
    );
  }

  if (data.carts.length === 0) {
    return <CartEmpty lang={lang} />;
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr] lg:gap-4 px-5 lg:px-40 2xl:px-96">
      <CartProvider>
        <CartList lang={lang} carts={data.carts} dataDate={data.date} />
        <CartTotalBox lang={lang} carts={data.carts} />
      </CartProvider>
    </div>
  );
}

export default CartWrap;
